// noinspection TypeScriptValidateTypes

import { defineStore } from 'pinia';

export const useNewsStore = defineStore('news', {
  state: () => ({
    newsData: loadFromLocalStorage('newsData') || {},
    bannersData: loadFromLocalStorage('bannersData') || {},
  }),
  actions: {
    setData(data: any[]) {
      this.newsData = data; // Não é necessário usar toRaw() aqui
      localStorage.setItem('newsData', JSON.stringify(data));
    },
    setBannersData(dataBanner: any[]) {
      this.bannersData = dataBanner; // Não é necessário usar toRaw() aqui
      localStorage.setItem('bannersData', JSON.stringify(dataBanner));    
    },
    getNew(): any {
      let filterData = this.newsData
      return filterData
    },
    
    getBanners(): any {
      let filterDataBanner = this.bannersData
      return filterDataBanner
    },
    
  }
  
});
function loadFromLocalStorage(key) {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (error) {
    return null;
  }
}